import React, { JSX } from 'react'
import * as S from './styles'

import FormBox from './FormBox'
import InfoSlider from './InfoSlider'

import Image from 'next/image'
import { Slide, SliderSettings } from '@/types/components/Login'

const imgRect = '/assets/images/retangulo.svg'
const imgRect2 = '/assets/images/retangulo2.svg'
const imgRect3 = '/assets/images/retangulo3.svg'
const imgRect4 = '/assets/images/retangulo4.svg'

interface LoginProps {
  id: string
  sliderSettings: SliderSettings
  slidesData: Array<Slide>
  formBoxContent: JSX.Element
  controlsTop: string
  controlsLeft?: string
  isLoading: boolean
  loadingClass: string
}

const Login = ({
  id,
  sliderSettings,
  slidesData,
  formBoxContent,
  controlsTop,
  controlsLeft,
  isLoading,
  loadingClass
}: LoginProps) => {
  return (
    <S.LoginWrapper id={id}>
      <InfoSlider
        settings={sliderSettings}
        slides={slidesData}
        controlsTop={controlsTop}
        controlsLeft={controlsLeft}
      />
      <S.LoginContainer className="flexbox">
        <Image id="rect1" src={imgRect} alt="" width={77} height={155} />
        <Image id="rect2" src={imgRect2} alt="" width={69} height={155} />

        <div id="spacer"></div>
        <div id="formbox-container" className="flexbox v-centered h-centered">
          <FormBox
            isLoading={isLoading}
            html={formBoxContent}
            loadingClass={loadingClass}
          />
        </div>
      </S.LoginContainer>
      <S.BoxesContainer>
        <Image id="rect3" src={imgRect3} alt="" width={71} height={76} />
        <Image id="rect4" src={imgRect4} alt="" width={86} height={77} />
      </S.BoxesContainer>
    </S.LoginWrapper>
  )
}

export default Login
